import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTaxAuthority, TaxAuthority } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<TaxAuthority>
      useData={useTaxAuthority}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
